import { render, staticRenderFns } from "./RmaDocuments.vue?vue&type=template&id=3466078b&scoped=true"
import script from "./RmaDocuments.vue?vue&type=script&lang=js"
export * from "./RmaDocuments.vue?vue&type=script&lang=js"
import style0 from "./RmaDocuments.vue?vue&type=style&index=0&id=3466078b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3466078b",
  null
  
)

export default component.exports